export const TERMINALS_FEATURES = {
  moduleKey: 'terminals',
  features: ['terminals.devices'],
  featureMeta: {
    'terminals.devices': {
      name: 'Terminals',
      translations: {
        name: { de: 'Terminals', en: 'Terminals', fr: 'Terminaux', it: 'Terminali' },
      },
    },
  },
} as const;
